import { ark } from "@ark-ui/react/factory";
import { type ComponentProps, forwardRef } from "react";
import { Stack, type StackProps, styled } from "@repo/styled-system/jsx";
import { skeleton } from "@repo/styled-system/recipes";
import type { HTMLStyledProps } from "@repo/styled-system/types/jsx";

export type SkeletonProps = ComponentProps<typeof Skeleton> & HTMLStyledProps<"div">;
export const Skeleton = styled(ark.div, skeleton);

export type SkeletonCircleProps = ComponentProps<typeof SkeletonCircle> & HTMLStyledProps<"div">;
export const SkeletonCircle = styled(ark.div, skeleton, { defaultProps: { circle: true } });

export type SkeletonTextProps = SkeletonProps & {
  /**
   * Number of lines to display
   * @default 3
   */
  noOfLines?: number | undefined;
  rootProps?: StackProps | undefined;
};

export const SkeletonText = forwardRef<HTMLDivElement, SkeletonTextProps>(
  function SkeletonText(props, ref) {
    const { noOfLines = 3, gap, rootProps, ...skeletonProps } = props;
    return (
      <Stack ref={ref} gap={gap} width="full" {...rootProps}>
        {[...Array(noOfLines).keys()].map((index) => (
          <Skeleton
            key={index}
            height="4"
            _last={{ maxW: noOfLines === 1 ? "100%" : "80%" }}
            {...skeletonProps}
          />
        ))}
      </Stack>
    );
  },
);
